import React from "react";
import CallToActionBtn from "components/Reusables/CallToActionBtn";
import { colors } from "utils/styles";

export default function ScheduleAdvisingSession() {
	return (
		<CallToActionBtn
			variant="dark"
			text="Schedule Free Advising Session"
			icon="calendar"
			iconColor={colors.white}
			iconStyle={{ marginRight: "0.5em" }}
			link="/schedule-advising-session"
		/>
	);
}
